import { Consts } from "../Consts";

async function parseJsonSafe(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}

export async function fetchModeratorView() {
  const response = await fetch(
    `${Consts.baseUrl}api/events/${localStorage.getItem("event")}/moderator-view`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  );

  const responseBody = await parseJsonSafe(response);
  if (!response.ok) {
    return {
      ok: false,
      status: response.status,
      error: responseBody?.error?.message ?? "Nem sikerült betölteni a moderátori nézetet.",
    };
  }

  return {
    ok: true,
    data: responseBody,
  };
}

export async function updateModeratorGroups(participantUserId, groups) {
  const response = await fetch(
    `${Consts.baseUrl}api/events/${localStorage.getItem("event")}/moderator-groups/${participantUserId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({ groups }),
    }
  );

  const responseBody = await parseJsonSafe(response);
  if (!response.ok) {
    return {
      ok: false,
      status: response.status,
      error: responseBody?.error?.message ?? "Nem sikerült menteni a csoportokat.",
    };
  }

  return {
    ok: true,
    data: responseBody,
  };
}

export async function saveModeratorGroups(groups) {
  const response = await fetch(
    `${Consts.baseUrl}api/events/${localStorage.getItem("event")}/moderator-groups`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({ groups }),
    }
  );

  const responseBody = await parseJsonSafe(response);
  if (!response.ok) {
    return {
      ok: false,
      status: response.status,
      error: responseBody?.error?.message ?? "Nem sikerült menteni a csoportokat.",
    };
  }

  return {
    ok: true,
    data: responseBody,
  };
}

export async function saveModeratorNotes(participantUserId, moderatorNotes) {
  const response = await fetch(
    `${Consts.baseUrl}api/events/${localStorage.getItem("event")}/moderator-notes/${participantUserId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({ moderatorNotes }),
    }
  );

  const responseBody = await parseJsonSafe(response);
  if (!response.ok) {
    return {
      ok: false,
      status: response.status,
      error: responseBody?.error?.message ?? "Nem sikerült menteni a moderátori jegyzetet.",
    };
  }

  return {
    ok: true,
    data: responseBody,
  };
}

export async function downloadModeratorNotesExport() {
  const response = await fetch(
    `${Consts.baseUrl}api/events/${localStorage.getItem("event")}/moderator-notes-export`,
    {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }
  );

  if (!response.ok) {
    const responseBody = await parseJsonSafe(response);
    return {
      ok: false,
      status: response.status,
      error: responseBody?.error?.message ?? "Nem sikerült exportálni a moderátori jegyzeteket.",
    };
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get("content-disposition") ?? "";
  const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  const fileName = fileNameMatch?.[1] ?? `moderatori-jegyzetek-${localStorage.getItem("event")}.xlsx`;

  return {
    ok: true,
    blob,
    fileName,
  };
}
